import styled from "styled-components";
import { Container } from "../grid";
export const CarouselWrapper = styled.div `
  position: relative;
  [data-testid="carousel-button-right"],
  [data-testid="carousel-button-left"] {
    display: none;
  }

  [data-testid="carousel-indicator"] {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 1rem;
    z-index: 10;

    @media ${({ theme }) => theme.device.medium} {
      bottom: 1.5rem;
    }
  }

  li {
    position: relative;
  }
`;
export const CustomButtonWrapper = styled(Container) `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  margin-left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
  z-index: 9;

  @media ${({ theme }) => theme.device.small} {
    /* display: none; */
  }
  @media ${({ theme }) => theme.device.medium} {
    display: block;
  }

  button {
    border: 1px solid ${({ theme, color }) => theme.colors[color]};
    position: absolute;
    top: 50%;
    bottom: 0;
    transform: translateY(-50%);
    display: none;
    align-items: center;
    pointer-events: all;

    &:first-of-type {
      left: 1.5rem;
    }

    &:last-of-type {
      right: 1.5rem;
    }

    @media ${({ theme }) => theme.device.medium} {
      display: flex;
    }

    &:disabled {
      svg {
        fill: ${({ theme, color }) => `rgba(${color === "white"
    ? theme.colors.transparentWhite
    : theme.colors.transparentBlack}, 0.2)`};
      }
    }

    svg {
      fill: ${({ theme, color }) => theme.colors[color]};
    }
  }
`;
